export default "/images/d467c5e95a3f883293e6b939509b8168.avif";